import { render, staticRenderFns } from "./upload-audio.vue?vue&type=template&id=815d974a&scoped=true&"
import script from "./upload-audio.vue?vue&type=script&lang=js&"
export * from "./upload-audio.vue?vue&type=script&lang=js&"
import style0 from "./upload-audio.vue?vue&type=style&index=0&id=815d974a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815d974a",
  null
  
)

export default component.exports